module.exports = __webpack_public_path__ + "img/search-icon.5d3381dc.svg";